lmApp
  .directive('lmAssetLocalization', [function () {
    return {
      restrict: 'E',
      scope: {
        asset: '='
      },
      replace: true,
      controller: 'LmAssetLocalizationController',
      templateUrl: 'lm-asset-localization/lm-asset-localization.html'
    };
  }]);

lmApp
  .controller('LmAssetLocalizationController', ['$scope', '$rootScope', '$templateCache', '$compile', '$q', '$timeout', 'MetadataService', 'ModalWindowService', 'AssetService', 'IMDbService', 'ToastService', 'GroupService', 'OfferService', 'PlanService', 'PackageService', 'YoutubeService',
    function ($scope, $rootScope, $templateCache, $compile, $q, $timeout, MetadataService, ModalWindowService, AssetService, IMDbService, ToastService, GroupService, OfferService, PlanService, PackageService, YoutubeService) {

      $scope.languages = MetadataService.languages;
      $scope.assetsLocalization = [];
      $scope.newLocalizationItem = { language: {}, title: '', description: '' };

      MetadataService.GetLocalization('assets', $scope.asset.id).then(function (response) {
        for (var localizationItem in response.data) {
          var language = _.find($scope.languages.list, { id: localizationItem });
          var localization = {};
          localization.language = language.title;
          localization.title = response.data[localizationItem].title;
          localization.description = response.data[localizationItem].description;
          $scope.assetsLocalization.push(localization);
        }
      });

      $scope.createLocalizationWindow = function (assetsLocalization, languages, newLocalizationItem) {
        $scope.freeLanguages = {};
        $scope.freeLanguages.list = [];
        languages.list.forEach(function (languageItem) {
          var localizationItem = _.find(assetsLocalization, { language: languageItem.title });
          if (!localizationItem) {
            $scope.freeLanguages.list.push(languageItem);
          }
        });

        $scope.newLocalizationWindow = $templateCache.get('add-asset-localization.html');
        $scope.newLocalizationWindow = $compile($scope.newLocalizationWindow)($scope);
        ModalWindowService.Open({
          content: $scope.newLocalizationWindow,
          size: {
            s: 6
          },
          actions: [
            {
              title: 'Create',
              color: 'lm',
              fn: function () {
                $scope.createNewLocalization(assetsLocalization, newLocalizationItem);
              },
              className: 'btn-ghost'
            },
            {
              title: 'Cancel',
              color: 'grey',
              className: 'btn-ghost'
            }
          ],
          keyboard: true
        });
      };

      $scope.createNewLocalization = function (assetsLocalization, newLocalizationItem) {
        if (newLocalizationItem.language.id && newLocalizationItem.title && newLocalizationItem.description) {
          var data = {};
          assetsLocalization.forEach(function (localizationItem) {
            var languageItem = _.find($scope.languages.list, { title: localizationItem.language });
            data[languageItem.id] = { title: localizationItem.title, description: localizationItem.description };
          });

          var addedLocalizationItem = {};
          addedLocalizationItem[newLocalizationItem.language.id] = { title: newLocalizationItem.title, description: newLocalizationItem.description }
          data = Object.assign(data, addedLocalizationItem);

          MetadataService.PatchLocalization('assets', $scope.asset.id, data).then(function () {
            var localization = {};
            localization.language = newLocalizationItem.language.title;
            localization.title = newLocalizationItem.title;
            localization.description = newLocalizationItem.description;
            assetsLocalization.push(localization);
            $scope.newLocalizationItem = { language: {}, title: '', description: '' };
          });
        }
      };

      $scope.deleteLocalizationItem = function (assetsLocalization, deletedIndex) {
        assetsLocalization.splice(deletedIndex, 1);
        var data = {};
        assetsLocalization.forEach(function (localizationItem) {
          var languageItem = _.find($scope.languages.list, { title: localizationItem.language });
          data[languageItem.id] = { title: localizationItem.title, description: localizationItem.description };
        });
        MetadataService.PatchLocalization('assets', $scope.asset.id, data);
      }

    }]);
